import BtnClear from "./btn-clear";
export default BtnClear;
